export default __webpack_public_path__ + "static/barlow-v4-latin-600-e2663d8dc0169d3058085f923cb89f2d.woff2";